

export default function SectionWrapper({ children, full = false }) {
  const className = "section shadow-xl " + (full ? "" : "p-16 ")

  return (
    <div className={className}>
      {children}
    </div>
  );
}
